import { useCallback, useEffect } from 'react';
export var useOnClickOutside = function (containerRef, onClickOutside) {
    var outsideClick = useCallback(function (e) {
        if (containerRef.current && !containerRef.current.contains(e.target)) {
            onClickOutside();
        }
    }, [containerRef, onClickOutside]);
    useEffect(function () {
        document.addEventListener('click', outsideClick);
        return function () { return document.removeEventListener('click', outsideClick); };
    }, [containerRef, onClickOutside]);
};
